import React from "react";

import { formatDate } from "../../../shared/utility";
import TextAreaTsx from "../../controls/TextAreaTsx";

interface WorkOrderStatus {
  label: string;
  value: number;
  type: string;
}

interface WorkOrder {
  id: number;
  work_number: string;
  customer_name: string;
  employee_name: string;
  start_date: string;
  end_date: string;
  reason: string;
  make: string;
  model: string;
  type: string;
  serial: string;
  work_performed: string;
  recommendations: string;
  notes: string;
  status: WorkOrderStatus;
}

interface WorkOrderDetailsModelProps {
  workOrder: WorkOrder;
  closeModal: () => {};
  goToDetails: () => {};
}

export default function WorkOrderDetailsModel({
  workOrder,
  closeModal,
  goToDetails,
}: WorkOrderDetailsModelProps) {
  return (
    <div className="justify-between">
      <div>
        <div className="grid grid-cols-2 gap-2">
          <h3 className="text-lg leading-6 font-normal text-gray-900">
            <span className="font-bold">WO #:</span> {workOrder.work_number}
          </h3>
          <h3 className="text-lg leading-6 font-normal text-gray-900">
            <span className="font-bold">Customer:</span>{" "}
            {workOrder.customer_name}
          </h3>
          <h3 className="text-lg leading-6 font-normal text-gray-900">
            <span className="font-bold">Tech.:</span> {workOrder.employee_name}
          </h3>
          <h3 className="text-lg leading-6 font-normal text-gray-900">
            <span className="font-bold">Start date:</span>{" "}
            {formatDate(workOrder.start_date)}
          </h3>
          <h3 className="text-lg leading-6 font-normal text-gray-900">
            <span className="font-bold">Status:</span> {workOrder.status.label}
          </h3>
        </div>

        <div className="py-1 gap-4 bg-white sm:rounded-xl">
          <div className="grid grid-cols-1 gap-4 w-full">
            <TextAreaTsx
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              labelOn={false}
              name="Reason"
              onChange={() => {}}
              value={workOrder.reason}
              rows={3}
              disabled={true}
            />

            <TextAreaTsx
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              labelOn={false}
              name="Work Performed"
              onChange={() => {}}
              value={workOrder.work_performed}
              rows={3}
              disabled={true}
            />

            <TextAreaTsx
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              labelOn={false}
              name="Recommendations"
              onChange={() => {}}
              value={workOrder.recommendations}
              rows={3}
              disabled={true}
            />

            <TextAreaTsx
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm max-w-lg"
              labelOn={false}
              name="Notes"
              onChange={() => {}}
              value={workOrder.notes}
              rows={3}
              disabled={true}
            />
          </div>

          <div className="my-auto justify-end">
            <button
              onClick={closeModal}
              className="inline-flex float-right mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 items-center"
            >
              Close
            </button>
            <button
              onClick={goToDetails}
              className="mr-2 inline-flex float-right mt-3 py-35-custom px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-700 items-center"
            >
              View more
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
